/**
 * Converte o estado do seletor de características (chaves `p{grupo}_char{id}`
 * e `p{grupo}_char{id}_value`) no payload da API.
 *
 * Devolve os dois formatos: `charateristics` (ids, formato antigo que o
 * back-end continua a aceitar) e `characteristics` (com valor, que tem
 * prioridade no back-end).
 */
export interface CharacteristicPayloadItem {
  id: number;
  value?: number | null;
  valueText?: string | null;
}

const CONTROL_PATTERN = /^p(\d+)_char(\d+)$/;

export function buildCharacteristicsPayload(
  data: Record<string, any> | null | undefined,
  catalog: any,
): { ids: number[]; items: CharacteristicPayloadItem[] } {
  const valueTypes = new Map<number, string>();
  for (const group of catalog?.characteristics ?? []) {
    for (const char of group?.char ?? []) {
      valueTypes.set(Number(char.id), `${char.valueType ?? 'BOOLEAN'}`);
    }
  }

  const items: CharacteristicPayloadItem[] = [];
  const seen = new Set<number>();
  for (const [key, selected] of Object.entries(data ?? {})) {
    const match = CONTROL_PATTERN.exec(key);
    if (!match || !selected) continue;
    const id = Number(match[2]);
    if (seen.has(id)) continue;
    seen.add(id);

    const raw = data?.[`${key}_value`];
    const valueType = valueTypes.get(id) ?? 'BOOLEAN';
    const item: CharacteristicPayloadItem = { id };
    if (valueType === 'NUMBER') {
      const n = Number(raw);
      item.value = Number.isFinite(n) && n > 0 ? Math.trunc(n) : 1;
    } else if (valueType === 'SELECT') {
      item.valueText = raw !== null && raw !== undefined && `${raw}` !== '' ? `${raw}` : null;
    }
    items.push(item);
  }

  return { ids: items.map((i) => i.id), items };
}
